import React, {Component} from "react";
// import ToolTipWrapper from '../../hoc/Wrp/ToolTipWrapper';
import Icons from '../../Components/Icons/Icons';
import Wrp from '../../hoc/Wrp/Wrp';
import $ from 'jquery';
import {isSet} from '../../Utils/CommonFunctions';
import {getWindowNameUsingDefinedName} from '../../Utils/UserFunctions';
import { dedupeWindowFieldsByColumnDescriptor, buildDuplicateFieldNameSet, getWindowFieldLayoutLabel } from '../../Utils/WindowFieldUtil';

class DrillDown extends Component{
    state = {
        isModalOpen:false,
        windowFields:[],
        drillDownData:[],
        selectedValue:[],
        searchText:'',
        rand:0,
        noneField:{id:'',field_name:'-None-',filter_field:true,filterWindow:true,assign_field:true},
        excludeFields : ['Created At','Updated At','AutoNumber','Created By','Updated By','Reminder','Barcode','Formula'],
        isFromEmail:this.props.isfromemail ? true : false
    }
    srchtextRef = React.createRef();
    divBlockRef = React.createRef();

    constructor(props){
        super(props);
        this.ref = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentWillMount = ()=>{
        // this.setWindowFieldsData();
        if(!this.props.isDisableOutSideClick)
        document.addEventListener('click', this.handleClickOutside, true);
    }
    componentWillUnmount=()=>{
     if(!this.props.isDisableOutSideClick)
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    componentDidUpdate = async (prevProps,prevState)=>{
        setTimeout(() => {
            if(this.props.isModelOpenDefault===false){
                this.srchtextRef.current?.focus();
            }
            
          }, 100);
        if((prevProps.fieldDetails !== this.props.fieldDetails)) {
            //console.log('componentDidUpdate111 fieldDetails')
            // this.setWindowFieldsData();
        }
        if((this.state.isModalOpen===true || this.props.isModelOpenDefault===true) && (prevProps.fieldDetails !== this.props.fieldDetails || isSet(this.state.windowFields, []).length===0)){
            // console.log('triggeredGetData....',this.state.isModalOpen,this.props.isModelOpenDefault,prevProps.fieldDetails !== this.props.fieldDetails,isSet(this.state.windowFields, []).length);
            this.setWindowFieldsData();
        }
        if(prevProps.fieldDetails?.fields_with_filters?.window_fields!==this.props.fieldDetails?.fields_with_filters?.window_fields){
            // console.log('triggered..');
            this.setWindowFieldsData();
        }
        if(prevProps.selectedValue!==this.props.selectedValue){
            //console.log('componentDidUpdate222 selectedValue',prevProps.selectedValue,this.props.selectedValue)            
             this.updateSelectedfields();
            // this.setWindowFieldsData();

        }
    }

    componentDidMount = ()=>{
        // this.setWindowFieldsData();
        this.updateSelectedfields();
    }
    updateSelectedfields = ()=>{
        this.setState({selectedValue:this.props.selectedValue});
    }
    setWindowFieldsData = () => {
        // console.log('itemInd one...');
        let fields = this.getWindowFields();
        
    }

    handleClickOutside(event) {
        if (this.ref.current && !this.ref.current.contains(event.target)) {
            if(this.props.allowAutoClose===true)this.closeModel(0);
        }
    };

    getWindowFields = (isGoBack=false) => {
        //console.log('getWindowFields==')
        const {selectedValue,isConditionApplied} = this.props;
        // const {fieldDetails,addExtraFields} = Object.assign({}, this.props);
        // const {fieldDetails,addExtraFields} = JSON.parse(JSON.stringify(this.props));
        if(this.props.fieldDetails!==undefined){
            const fieldDetails = this.props.fieldDetails;//JSON.parse(JSON.stringify(this.props.fieldDetails));JSON.parse(JSON.stringify(this.props.addExtraFields))
           
            const addExtraFields = this.props.addExtraFields ? this.props.addExtraFields : [];        
            let fields = fieldDetails && fieldDetails.fields_with_filters && fieldDetails.fields_with_filters.window_fields ? fieldDetails.fields_with_filters.window_fields : [];        
            fields = this.addMasterWindowLayouts(fieldDetails,fields);
            if(addExtraFields) {
                fields = this.addExtraFieldGroup(addExtraFields,fields);
            }
            if(this.props.isPickListFilter === true && this.props.isCondtionField === true){
                this.preparePickList(fields);
            }
                
            //Currency field    
            fields = this.prepareCurrencyList(fields);
            fields = dedupeWindowFieldsByColumnDescriptor(fields);
            
            // console.log('getWindowFields===',fields);
            const updateState = {...this.state};
            if(isConditionApplied && isConditionApplied === true &&fields && selectedValue && isGoBack === false) {
                if(selectedValue.length > 1) {
                    updateState['drillDownData'] = [];
                    if(Array.isArray(selectedValue)===false){
                        selectedValue = [{field_name:'-None-',id:''}];
                    }
                    selectedValue.forEach((valItem) => {
                        fields.forEach((fieldItem) => {
                            if(valItem.field_name === fieldItem.field_name  || (fieldItem.dependent_layout && fieldItem.dependent_layout['window_name'] && fieldItem.dependent_layout['window_name']===valItem.field_name)) {
                            if(fieldItem.dependent_layout && 
                                fieldItem.dependent_layout.fields_with_filters &&
                                fieldItem.dependent_layout.fields_with_filters.window_fields)  {
                                    fields = fieldItem.dependent_layout.fields_with_filters.window_fields;
                                    updateState['drillDownData'].push(fieldItem);
                                    // selectedFields.push({field_name:fieldItem.field_name})
                            }
                        }
                    })
                })
            }else {
                updateState['drillDownData'] = [];
            }
        }else {
            updateState['drillDownData'] = [];
        }
        let fieldsNone = this.addNoneField();
        // console.log('windowFields...', [...fieldsNone,...fields]);
        updateState['windowFields'] = [...fieldsNone,...fields];
        this.setState(updateState);
        return [...fieldsNone,...fields];
        }
    }

    //ADD NONE FIELD
    addNoneField = () => {
        let noneField = [];
        noneField.push(this.state.noneField);
        //console.log(noneField,'noneField')
        return noneField;
    }

    //ADD MASTER WINDOWS FIELDS DETAILS
    addMasterWindowLayouts = (fieldDetails,configField)=>{
        if(fieldDetails!==undefined && fieldDetails.master_window_layouts!==undefined){
            fieldDetails.master_window_layouts.map((masfields)=>{
                configField.push({
                    id : isSet(masfields.id,masfields.window_Id),
                    api_field_name : '',
                    field_name:masfields.window_name,
                    level:0,
                    isDepenedField: true,
                    depenedFields:[],
                    is_master_window : true,
                    is_custom_field : true,
                })
            });
        }
        return configField;
    }

    //FIND AND MERGE NON-GRO USING ID FROM FILDER-GROUPS
    addExtraFieldGroup = (extraFields,configField)=>{
        if(extraFields!==undefined)
        extraFields.map((item)=>{
                configField.push({
                    id:item.id,
                    element:item.variable_type,
                    filters:item.filters,
                    api_field_name:item.api_name ? item.api_name : item.variable_name,
                    field_name:item.variable_name,
                    field_type:item.fieldtype_name, //variable_type
                    fieldTypeId:item.id,
                    level:0,
                    function_type:item.function_type,
                    fieldName:item.variable_name,
                    isDepenedField:false,
                    depenedFields:[],
                    options:[],
                    is_custom_field : true,
                    is_master_window : false,
                    dependent_layout : this.recursiveFields(item),
                    lookup_window_name:(item.fields && item.fields.length>0)?item.variable_name:'',
                    system_window_name:(item.fields && item.fields.length>0)?item.variable_name:null,
                    variable_field_id_path:item.id,
                    filter_field:true
                })
        });
        return configField;
    }

    recursiveFields = (item,rateVariablePath='') => {
        let fields = null;
        //if(item.fieldtype_name === "Array") {
        if(item.fields && item.fields.length>0) {
            let ratePath = (rateVariablePath!=='')?rateVariablePath:item.id;
            fields = {
              id:item.id,
              element:item.variable_type,
              filters:item.filters,
              api_field_name:item.api_name ? item.api_name : (item.variable_name)?item.variable_name:item.name,
              field_name:(item.variable_name)?item.variable_name:item.name,
              field_type:(item.fieldtype_name)?item.fieldtype_name:item.field_type_name,
              fieldTypeId:item.id,
              level:0,
              fieldName:(item.variable_name)?item.variable_name:item.name,
              display_name:(item.variable_name)?item.variable_name:item.name,
              isDepenedField:false,
              depenedFields:[],
              options:[],
              is_custom_field : true,
              is_master_window : false,
              window_id:item.id,
              lookup_window_name:(item.fields && item.fields.length>0)?(item.variable_name)?item.variable_name:item.name:'',
              system_window_name:(item.fields && item.fields.length>0)?(item.variable_name)?item.variable_name:item.name:null,
              fields_with_filters:{
                  field_groups : null,
                  window_fields : this.convertVariablesToWindowFields(item.fields,item,ratePath)
              },
              variable_field_id_path:ratePath,
              filter_field:true
            }
        }
        return fields;
    }

    convertVariablesToWindowFields = (fields,itemP,ratePath='')=>{
        let variables = [];
        if(fields!==undefined)            
        fields.map((item)=>{
            let rateVariablePath = (ratePath!=='')?ratePath+'.'+item.id:itemP.id+'.'+item.id;
                variables.push({
                    id:item.id,
                    element:item.variable_type,
                    filters:item.filters,
                    api_field_name:item.api_name ? item.api_name :item.name,
                    field_name:item.name,
                    field_type:(item.fieldtype_name)?item.fieldtype_name:item.field_type_name,
                    fieldTypeId:item.id,
                    level:0,
                    fieldName:item.name,
                    isDepenedField:false,
                    depenedFields:[],
                    options:[],
                    is_custom_field : true,
                    is_master_window : false,
                    lookup_window_name:(item.fields && item.fields.length>0)?item.name:'',
                    system_window_name:(item.fields && item.fields.length>0)?item.name:null,
                    // fifff:item,
                    dependent_layout : this.recursiveFields(item,rateVariablePath),
                    variable_field_id_path:rateVariablePath,
                    filter_field:true
                })
        });
        return variables;
    }

    toggleModel = () => {
        // let fields = this.getWindowFields();
        $(".mainDiv").css({'display':'block'});
        $(".noFields").hide();        
        setTimeout(() => {
            this.divBlockRef.current.focus();
            // this.srchtextRef.current.focus();
        },100);
        this.setState({isModalOpen:!this.state.isModalOpen,/*drillDownData:[],*/rand:2,searchText:''});
        this.scrollTop();
        // alert('dd');
    }

    closeModel = (time) => {
        let timeout = 500;
        if(time!==undefined){
            timeout=time;
        }
        setTimeout(() => {
            if(this.state.rand === 0) {
                // let fields = this.getWindowFields();
                this.setState({isModalOpen:false,drillDownData:[],rand:0});
            }else if(this.state.rand === 2) {
                if(this.divBlockRef && this.divBlockRef.current) {
                    this.divBlockRef.current.focus();    
                }
                this.setState({rand:0});
            }
        },timeout);
        
    }

    closeModel1 = (val) => {
        this.setState({rand:val});
        // this.divBlockRef.current.focus();
        // setTimeout(() => {
        //     this.setState({rand:1});
        // },100);
        
    }

    drillDownNextLevel = (parentData) => {
        const prntData = JSON.parse(parentData);
        let windowFields = prntData.dependent_layout.fields_with_filters.window_fields;
        let fieldsNone = this.addNoneField();
        //windowFields.push(this.state.noneField);
        const drillData = {...this.state};
        drillData['drillDownData'].push(prntData);
        drillData['windowFields'] = [...fieldsNone,...windowFields];
        this.setState(drillData);

        this.childSearchHandler('');
        // this.divBlockRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // this.scrollTop();

    }

    goBackDrillDown = (itemInd) => {
        const list = {...this.state};
        let existData = this.state.drillDownData;
        // console.log('itemInd',itemInd,existData);
        const slicedArray = existData.slice(0, itemInd+1);
        if(itemInd !== -1) {
          list['drillDownData'] = slicedArray;
          if(slicedArray.length > 0) {
            list['windowFields'] = slicedArray[slicedArray.length-1].dependent_layout.fields_with_filters.window_fields;
          }else {
            list['windowFields'] = this.getWindowFields();
          }
        }else {
            // console.log('itemInd -else',this.getWindowFields(true));
          
          list['drillDownData'] = [];
          list['windowFields'] = this.getWindowFields(true);
        //   this.getWindowFields(true);
        }
        this.setState(list);

        this.childSearchHandler('');
        // this.scrollTop();
    }

    selectHandler = (obj) => {
        // console.log(obj)
        if(obj && obj.id !== '') {
            const data = [...this.state.drillDownData];
            data.push(obj);
            let selectedValue = [];
            if(data) {
                data.map((item,ind) => {
                    item['element'] = item.field_type;
                    item['lookUpName'] = item.lookup_window_name;
                    item['windowName'] = item.window_name;
                    item['is_custom_field'] = item.is_custom_field;
                    item['is_master_window'] = item.is_master_window;
                    item['system_window_name'] = item.dependent_layout ? item.dependent_layout.window_name : null;
                    item['system_window_id'] = item.dependent_layout ? item.dependent_layout.window_id : null;
                    // Keep id so duplicate labels (e.g. two "POD Exist") select independently.
                    selectedValue.push({
                        field_name: item.field_name,
                        id: item.id,
                        layout_name: getWindowFieldLayoutLabel(item),
                    });
                })
            }
            this.setState({selectedValue:selectedValue,isModalOpen:false,rand:2});
            // console.log(data);
            this.props.selectHandler(data);
        }else {
            this.setState({selectedValue:[],drillDownData:[],isModalOpen:false,rand:2});
            this.props.selectHandler(null);
        }
    }

    childSearchHandler = (value) => {
        let id = (this.props.drillId)!==undefined?"#"+this.props.drillId+"_fields":"";
        var filter = value.toLowerCase();
        this.setState({searchText:value});
        $(id+" .mainDiv").each(function () {
            if ($(this).text().toLowerCase().search(new RegExp(filter, "i")) < 0) {
                //$(this).hide();
                $(this).css({'display':'none'});                
            } else {
                //$(this).show();                
                $(this).css({'display':'block'});
            }
        });
        this.checkFieldExists();        
    }

    checkFieldExists = () => {
        let id = (this.props.drillId)!==undefined?"#"+this.props.drillId+"_fields":"";
        $(id+"_fields .noFields").hide();
        let isValThere = 0;
        $(id+"_fields .mainDiv").each(function () {           
           if($(this).css("display") === "block") {
            isValThere = 1;            
           }
        });
        if(isValThere === 0){
            $(id+"_fields .noFields").show();   
        }
    }

    scrollTop = () => {
        var elem = document.getElementById("ele");
        if(elem) {
            elem.scrollIntoView();    
        }
    }

    preparePickList = (windowFields) => {
        let fields = [];
        if(windowFields && windowFields.length>0) {
            windowFields.map((item,ind) => {
                const isAlreadyAssigned = item.isAlreadyAssigned!==undefined && item.isAlreadyAssigned!==null ? item.isAlreadyAssigned : false;
                if(item.field_type && (item.field_type === "PickList" || item.field_type === "MultiSelect") && !isAlreadyAssigned) {
                    let nameOptions=[];
                    if(item.options && item.options.length>0) {
                        item.options.map(optItem => {
                            nameOptions.push({
                                key: optItem.key,
                                value: optItem.value
                            })
                        })
                    }

                    let valueOptions=[];
                    if(item.options && item.options.length>0) {
                        item.options.map(optItem => {
                            valueOptions.push({
                                key: optItem.key,//optItem.api_value_id ? optItem.api_value_id : optItem.key,
                                value: optItem.api_value
                            })
                        })
                    }
                    let picklistData = item;
                    picklistData.dependent_layout={
                        fields_with_filters:{
                            field_groups : null,
                            window_fields : [{
                                api_field_name:"name",
                                id:item.id,
                                field_name:"Name",
                                field_type:"PickList" ,
                                options:nameOptions,
                                filters:item.filters,
                                assignment_filters:item.assignment_filters,
                                assign_field:true,
                                filterWindow:true,
                                filter_field:true,
                                isAlreadyAssigned:true,
                                window_field_id_path:item.id+"."+item.id
                            },{
                                api_field_name:"value",
                                id:item.api_value_id,
                                field_name:"Value",
                                field_type:"PickList" ,
                                options:valueOptions,
                                filters:item.filters,
                                assignment_filters:item.assignment_filters,
                                assign_field:true,
                                filterWindow:true,
                                filter_field:true,
                                isAlreadyAssigned:true,
                                window_field_id_path:item.id+"."+item.api_value_id
                            }]
                        }
                    };
                    fields.push(picklistData);
                }else {
                    fields.push(item);
                }
            })
        }
        return fields;
    }
    prepareCurrencyList = (windowFields) => {
        let fieldsArr = [];
        if(windowFields && windowFields.length>0) {
            windowFields.forEach((item,ind) => {
                const isAlreadyAssigned = item.isAlreadyAssigned!==undefined && item.isAlreadyAssigned!==null ? item.isAlreadyAssigned : false;
                let itemObj = {
                    ...item
                }
                if((item.field_type || item.field_type_name) && (isSet(item.field_type,item.field_type_name) === "Currency") && !isAlreadyAssigned) {
                   
                    itemObj = {
                        ...itemObj,
                        dependent_layout:{
                            fields_with_filters:{
                                window_fields:[
                                    {
                                        api_field_name:'currency_code',
                                        value:isSet(item.currency_code,''),
                                        isAlreadyAssigned:true,
                                        field_name:'Currency code',
                                        assignment_filters:item.assignment_filters,
                                        assign_field:true,
                                        filterWindow:true,
                                        filter_field:true,
                                        options:[],
                                        id:item.id,
                                        field_type:'TextInput',
                                        window_field_id_path:item.id+'.currency_code',

                                    },{
                                        api_field_name:'value',
                                        value:isSet(item.value,''),
                                        isAlreadyAssigned:true,
                                        assignment_filters:item.assignment_filters,
                                        assign_field:true,
                                        filterWindow:true,
                                        filter_field:true,
                                        options:[],
                                        field_name:'value',
                                        field_type:'Decimal',
                                        id:item.id,
                                        window_field_id_path:item.id+'.value',

                                    }
                                ]
                            }
                        }
                    }
                }
                if(isSet(item.dependent_layout,null)!==null){
                    itemObj = {
                        ...itemObj,
                        dependent_layout:{
                            ...itemObj.dependent_layout,
                            fields_with_filters:{
                                ...itemObj.dependent_layout.fields_with_filters,
                                window_fields:this.prepareCurrencyList(item.dependent_layout.fields_with_filters.window_fields)
                            }
                        }
                    }
                }
                fieldsArr.push(itemObj);
            })
        }
        return fieldsArr;
    }

    render(){
        const {drillId,fieldDetails,isRateAssignment,children,isDisable,
            filterWindow,assignWindow,isLookupSelect,isModelOpenDefault,existWindowFields,isExcludeFields,isCustomChildren} = this.props;
        const {windowFields,drillDownData,isModalOpen,selectedValue,excludeFields} = this.state;
        let isModalOpenDef = isModalOpen;
        if(isModelOpenDefault===true){
            isModalOpenDef = true;
        }
        let val = '';
        let selectedMeta = { id: '', fieldName: '' };
        if(selectedValue && selectedValue.length > 0) {
            const lastSelected = selectedValue[selectedValue.length - 1] || {};
            val = lastSelected.field_name ? lastSelected.field_name : '';
            selectedMeta = {
                id: isSet(lastSelected.id, ''),
                fieldName: isSet(lastSelected.field_name, ''),
            };
        }
        const isItemChecked = (item) => {
            if (!item) {
                return false;
            }
            // Prefer table-descriptor id so same-named fields from different layouts stay independent.
            if (selectedMeta.id !== '' && isSet(item.id, '') !== '') {
                return selectedMeta.id === item.id;
            }
            return selectedMeta.fieldName !== '' && selectedMeta.fieldName === item.field_name;
        };
        const isDisabled = isDisable ? isDisable : false;
        // console.log('windowFields',windowFields,'existWindowFields',existWindowFields);
        // console.log('this.state.drillDownData',this.state.drillDownData)


        let resrictDrillDownFields = this.props.restrictWindowFields;
        let restrictWindows = [];
        if(resrictDrillDownFields.fields_with_filters && resrictDrillDownFields.fields_with_filters.window_fields && resrictDrillDownFields.fields_with_filters.window_fields.length>0){
            resrictDrillDownFields.fields_with_filters.window_fields.map((item,index)=>{
              if(item.dependent_layout){
                restrictWindows.push(item.dependent_layout.window_id)
              }  
            })
        }

        //console.log('restrictWindows',restrictWindows)
        let drillDownDataLength = drillDownData.length;
        //console.log('drillDownData===',drillDownData)

        let isDrill = false;
        //const {drillDownData} = this.state;
        const drillDownDataNew = [...drillDownData];
        if(drillDownDataLength>0){
            var lastItem = drillDownDataNew.pop();
            //console.log('lastItem',lastItem)
            if(restrictWindows.includes(lastItem.dependent_layout.window_id)){
                isDrill = true;
            } 
            // drillDownData.map((item,ind)=>{
            //     if(restrictWindows.includes(item.id)){
            //         isDrill = true;
            //     }    
            // })
            //restrictWindows.includes(drillDownData[ind]['window_field_id_path']
        }

        //console.log(this.state.drillDownData,this.props.selectedValue,this.state.selectedValue);
        //console.log('fieldDetails==',fieldDetails,this.props.selectedValue)
        // console.log('isModalOpenDef',isModalOpenDef,drillId);
        // Only used to disambiguate same display names from different layouts (e.g. POD Exist).
        // Unique labels stay unchanged — no hint clutter on existing fields.
        const duplicateFieldNames = buildDuplicateFieldNameSet(windowFields);
        const showLayoutHint = this.props.showLayoutHint === true;
        return (
            <Wrp>
                <div className={"d-flex cursor-pointer p-0 position-relative text-small drilldown-hoc"+this.props.hocClass}>
                {
                (isRateAssignment===true || isCustomChildren===true)?
                    <a  onClick={this.toggleModel}>
                        {children}
                    </a>
                    // <button className="btn btn-sm third_dark_bg" onClick={this.toggleModel}>Add Assignment </button>
                : 
                <Wrp>
                    {(isModelOpenDefault===false)?
                    <>
                    <input type="text" name="searchTxt" autoComplete={'off'} className="form-control custom-arrow" disabled={isDisabled} />
                    {isSet(this.props.isFetchingData,false)===true && 
                    <i
                    className="fas fa-spinner fa-spin fa-lg"
                    style={{
                        position: "absolute",
                        top: "35%",
                        right: "10px", // Adjust based on your padding
                        transform: "translateY(-50%)",
                        color: "#000", // Customize loader color
                        zIndex: '999'
                    }}></i>
                    }
                    </>
                        
                    :''}
                <div className="w-100 text-truncate pl-2 position-absolute pr-3 py-2" onClick={isDisabled === false ? this.toggleModel : null}>
                {
                    selectedValue && Array.isArray(selectedValue) && selectedValue.length>0 ?
                        selectedValue.map((item,ind) => {
                            return (
                            <Wrp key={ind}>
                                <span className="">
                                    {item.field_name}
                                </span>
                                {
                                    selectedValue.length !== ind+1 ?
                                        <span className="separator"> 
                                            <Icons iconType={"SeperatorIcon"} />
                                        </span>
                                    : null
                                }
                                
                            </Wrp>
                            )
                        })
                    : <span className="">
                        None
                      </span>
                }
                </div>
                </Wrp>
                }
                </div>
                <div  ref = {this.ref} className={isModalOpenDef === true ? "" : "hide"} style={{position:(this.props.isPositionRelative===true)?'relative':'inherit'}}>
                    <div ref={this.divBlockRef} tabIndex="0" className="p-0 dropdown-menu show dropdown-menu-left dropdownmenu-content dropnotHide mt-0"  /* w-100onBlur={e=>this.closeModel(e)}*/ style={{"minWidth": "250px",minWidth:'100%',position:(isModelOpenDefault===true)?'relative':'absolute'}}  >
                          
                        <div className="clearfix"> 
                            <div className="card-header p-1" id={drillId}>

                                <div className="d-flex">
                                    <ul className="breadcrumbs text-small" style={{"minWidth": "250px"}}>
                                        <li className="nav-item cursor-pointer">   
                                            {fieldDetails && fieldDetails.display_name ?
                                            <a onClick={e=>this.goBackDrillDown(-1)}  className=""> {fieldDetails.display_name ? fieldDetails.display_name : getWindowNameUsingDefinedName(fieldDetails.window_name)} </a>
                                            : <a onClick={e=>this.goBackDrillDown(-1)}  className=""> Field </a>
                                            }
                                        </li>
                                        <li className="separator">  <i className="fas fa-chevron-right fourth_light_color"></i>
                                        </li>
                                    {
                                      this.state.drillDownData ?
                                          this.state.drillDownData.map((item,ind) => {
                                            return (
                                                <Wrp key={ind} >
                                                <li className="nav-item cursor-pointer">   
                                                    <a onClick={e=>this.goBackDrillDown(ind)}  className=""> {item.field_name} </a>
                                                </li>
                                                <li className="separator">  <i className="fas fa-chevron-right fourth_light_color"></i>
                                                </li>
                                                </Wrp>
                                            )
                                          })
                                      : null
                                    }
                                    </ul>
                                    {(isModelOpenDefault===false)?
                                    <a onClick={this.toggleModel} className="icon-right cursor-pointer"><i className="fas fa-times-circle secondary_color"></i></a>
                                    :''}
                                </div>
                                
                                <input type="text" id="searchTxt" autoComplete={'off'}  autoFocus  onChange={e=>this.childSearchHandler(e.target.value)} value={this.state.searchText} ref={this.srchtextRef} className="form-control form-control-sm" placeholder="Search here...." /> 
                                
                                
                            </div>
                            <div className="card-body bg-light px-2 py-2 fixedHeight" id ={drillId+"_fields"}>                                <div className="card-list">
                                {
                                    (isModalOpenDef===true && windowFields) ?
                                        windowFields.map((item,ind) => {
                                            return (
                                                isExcludeFields === true && (excludeFields.indexOf(item.field_name) !== -1 || excludeFields.indexOf(item.field_type) !== -1 || item.field) ?
                                                    null
                                                :
                                                item.field_type!=='Blank'?
                                                existWindowFields.indexOf(item.id) === -1 ?                                                
                                                filterWindow && filterWindow===true ?
                                                item.filter_field === true ?
                                                <div className="mainDiv 8" id={ind === 0 ? "ele" : ""}>
                                                <div key={ind} className="d-flex align-items-center justify-content-between mb-1 ">
                                                    <div className="w-75 listClass">
                                                        <label className="d-flex align-items-center mb-0 cursor-pointer" >
                                                            <input type="radio" 
                                                                name={"fields_"+ind+drillId}
                                                                className=" " 
                                                                value={item.id}
                                                                checked={isItemChecked(item)} 
                                                                onClick={item.dependent_layout ? isLookupSelect === true ? e=>this.selectHandler(item) : null : e=>this.selectHandler(item)}
                                                            />
                                                            <span className="pl-1 text-truncate" title={item.field_name}>{item.field_name}</span>
                                                            {(isSet(item.function_type,null)!==null)?
                                                                <span className="text-dark text-medium ml-1" style={{opacity:'0.5',fontStyle:'italic',fontSize:'0.8rem'}}>({item.function_type})</span>
                                                            :<></>}
                                                            
                                                        </label>
                                                    </div>
                                                    {
                                                        item.dependent_layout ?
                                                            <div><a onClick={e=>this.drillDownNextLevel(JSON.stringify(item))} className="cursor-pointer">
                                                                <Icons iconType={"DoubleRightArrow"} /></a>
                                                            </div>
                                                        : null
                                                    }
                                                </div>
                                                </div> : null
                                                : assignWindow && assignWindow === true ?
                                                item.assign_field === true ?
                                                <div className="mainDiv 7" id={ind === 0 ? "ele" : ""}>
                                                <div key={ind} className="d-flex align-items-center justify-content-between mb-1 ">
                                                    <div className="w-75 listClass">
                                                        <label className="d-flex align-items-center mb-0 cursor-pointer" >
                                                            <input type="radio" 
                                                                name={"fields_"+ind+drillId}
                                                                className=" " 
                                                                value={item.id}
                                                                checked={isItemChecked(item)} 
                                                                onClick={item.dependent_layout ? isLookupSelect === true ? e=>this.selectHandler(item) : null : e=>this.selectHandler(item)}
                                                            />
                                                            <span className="pl-1 text-truncate" title={item.field_name}>{item.field_name}</span>
                                                            {(isSet(item.function_type,null)!==null)?
                                                                <span className="text-dark text-medium ml-1" style={{opacity:'0.5',fontStyle:'italic',fontSize:'0.8rem'}}>({item.function_type})</span>
                                                            :<></>}
                                                        </label>
                                                    </div>
                                                    {
                                                        item.dependent_layout ?
                                                            <div><a onClick={e=>this.drillDownNextLevel(JSON.stringify(item))} className="cursor-pointer">
                                                                <Icons iconType={"DoubleRightArrow"} /></a>
                                                            </div>
                                                        : null
                                                    }
                                                </div>
                                                </div> : null
                                                : 
                                                
                                                (this.props.imageField === false && item.field_type === 'Image' )
                                                ?
                                                null
                                                :
                                                (this.props.isRateAssignment === true)?
                                                        drillDownDataLength === 0?
                                                        <div className="mainDiv 6" id={ind === 0 ? "ele" : ""}>
                                                            <div key={ind} className="d-flex align-items-center justify-content-between mb-1 ">
                                                                <div className="w-75 listClass">
                                                                    <label className="d-flex align-items-center mb-0 cursor-pointer" >
                                                                        <input type="radio" 
                                                                            name={"fields_"+ind+drillId}
                                                                            className=" " 
                                                                            value={item.id}
                                                                            checked={isItemChecked(item)} 
                                                                            onClick={item.dependent_layout ? isLookupSelect === true ? e=>this.selectHandler(item) : null : e=>this.selectHandler(item)}
                                                                        />
                                                                        <span className="pl-1 text-truncate" title={item.field_name}>{item.field_name}</span>
                                                                        {(isSet(item.function_type,null)!==null)?
                                                                            <span className="text-dark text-medium ml-1" style={{opacity:'0.5',fontStyle:'italic',fontSize:'0.8rem'}}>({item.function_type})</span>
                                                                        :<></>}
                                                                    </label>
                                                                </div>
                                                                {
                                                                    
                                                                    item.dependent_layout && drillDownDataLength === 0?
                                                                        <div><a onClick={e=>this.drillDownNextLevel(JSON.stringify(item))} className="cursor-pointer">
                                                                            <Icons iconType={"DoubleRightArrow"} /></a>
                                                                        </div>
                                                                    :                                                                    
                                                                    null
                                                                }
                                                            </div>
                                                        </div>
                                                :drillDownDataLength>0?
                                                        ((item.field_type!=='Lookup' && item.field_type!=='MultiLookup' && item.field_type!=='Array' && item.field_type!=='Object'))?
                                                        <div className="mainDiv 5" id={ind === 0 ? "ele" : ""}>
                                                            <div key={ind} className="d-flex align-items-center justify-content-between mb-1 ">
                                                                <div className="w-75 listClass">
                                                                    <label className="d-flex align-items-center mb-0 cursor-pointer" >
                                                                        <input type="radio" 
                                                                            name={"fields_"+ind+drillId}
                                                                            className=" " 
                                                                            value={item.id}
                                                                            checked={isItemChecked(item)} 
                                                                            onClick={item.dependent_layout ? isLookupSelect === true ? e=>this.selectHandler(item) : null : e=>this.selectHandler(item)}
                                                                        />
                                                                        <span className="pl-1 text-truncate" title={item.field_name}>{item.field_name}</span>
                                                                        {(isSet(item.function_type,null)!==null)?
                                                                            <span className="text-dark text-medium ml-1" style={{opacity:'0.5',fontStyle:'italic',fontSize:'0.8rem'}}>({item.function_type})</span>
                                                                        :<></>}
                                                                    </label>
                                                                </div>
                                                                {
                                                                    
                                                                    item.dependent_layout?
                                                                        <div><a onClick={e=>this.drillDownNextLevel(JSON.stringify(item))} className="cursor-pointer">
                                                                            <Icons iconType={"DoubleRightArrow"} /></a>
                                                                        </div>
                                                                    :                                                                    
                                                                    null
                                                                }
                                                            </div>
                                                        </div>
                                                :(restrictWindows.length>0 && isDrill === true)?
                                                            <div className="mainDiv 4" id={ind === 0 ? "ele" : ""}>
                                                                <div key={ind} className="d-flex align-items-center justify-content-between mb-1 ">
                                                                    <div className="w-75 listClass">
                                                                        <label className="d-flex align-items-center mb-0 cursor-pointer" >
                                                                            <input type="radio" 
                                                                                name={"fields_"+ind+drillId}
                                                                                className=" " 
                                                                                value={item.id}
                                                                                checked={isItemChecked(item)} 
                                                                                onClick={item.dependent_layout ? isLookupSelect === true ? e=>this.selectHandler(item) : null : e=>this.selectHandler(item)}
                                                                            />
                                                                            <span className="pl-1 text-truncate" title={item.field_name}>{item.field_name}</span>
                                                                            {(isSet(item.function_type,null)!==null)?
                                                                                <span className="text-dark text-medium ml-1" style={{opacity:'0.5',fontStyle:'italic',fontSize:'0.8rem'}}>({item.function_type})</span>
                                                                            :<></>}
                                                                        </label>
                                                                    </div>
                                                                    {
                                                                        
                                                                        item.dependent_layout?
                                                                            <div><a onClick={e=>this.drillDownNextLevel(JSON.stringify(item))} className="cursor-pointer">
                                                                                <Icons iconType={"DoubleRightArrow"} /></a>
                                                                            </div>
                                                                        :                                                                    
                                                                        null
                                                                    }
                                                                </div>
                                                            </div>
                                                :(item.field_type==='Lookup' || item.field_type =='MultiLookup') ?
                                                            <div className="mainDiv 3" id={ind === 0 ? "ele" : ""}>
                                                            <div key={ind} className="d-flex align-items-center justify-content-between mb-1 ">
                                                                <div className="w-75 listClass">
                                                                    <label className="d-flex align-items-center mb-0 cursor-pointer" >
                                                                        <input type="radio" 
                                                                            name={"fields_"+ind+drillId}
                                                                            className=" " 
                                                                            value={item.id}
                                                                            checked={isItemChecked(item)} 
                                                                            onClick={item.dependent_layout ? isLookupSelect === true ? e=>this.selectHandler(item) : null : e=>this.selectHandler(item)}
                                                                        />
                                                                        <span className="pl-1 text-truncate" title={item.field_name}>{item.field_name}</span>
                                                                        {(isSet(item.function_type,null)!==null)?
                                                                            <span className="text-dark text-medium ml-1" style={{opacity:'0.5',fontStyle:'italic',fontSize:'0.8rem'}}>({item.function_type})</span>
                                                                        :<></>}
                                                                    </label>
                                                                </div>
                                                                {
                                                                    
                                                                    item.dependent_layout?
                                                                        <div><a onClick={e=>this.drillDownNextLevel(JSON.stringify(item))} className="cursor-pointer">
                                                                            <Icons iconType={"DoubleRightArrow"} /></a>
                                                                        </div>
                                                                    :                                                                    
                                                                    null
                                                                }
                                                            </div>
                                                        </div>
                                                :
                                                        <></>
                                                :
                                                null
                                                :(this.props.isDirectFieldOnly === false && this.props.isRateAssignment === false)?
                                                    <div className="mainDiv 2" id={ind === 0 ? "ele" : ""}>
                                                        <div key={ind} className="d-flex align-items-center justify-content-between mb-1 ">
                                                            <div className="w-85 listClass">
                                                                <label className="d-flex align-items-center mb-0 cursor-pointer" >
                                                                    <input type="radio" 
                                                                        name={"fields_"+drillId}
                                                                        className=" " 
                                                                        value={item.id}
                                                                        checked={isItemChecked(item)} 
                                                                        onClick={item.dependent_layout ? isLookupSelect === true ? e=>this.selectHandler(item) : null : e=>this.selectHandler(item)}
                                                                    />
                                                                    <span className="pl-1 text-truncate" title={item.field_name}>{item.field_name} </span>
                                                                    {renderLayoutVariantHint(item, duplicateFieldNames, showLayoutHint)}
                                                                    {(isSet(item.function_type,null)!==null)?
                                                                        <span className="text-dark text-medium ml-1" style={{opacity:'0.5',fontStyle:'italic',fontSize:'0.7rem'}}>({item.function_type})</span>
                                                                    :<></>}
                                                                   
                                                                </label>
                                                            </div>
                                                            {
                                                                item.dependent_layout && this.props.isRateAssignment === false?
                                                                    <div><a onClick={e=>this.drillDownNextLevel(JSON.stringify(item))} className="cursor-pointer">
                                                                        <Icons iconType={"DoubleRightArrow"} /></a>
                                                                    </div>
                                                                : 
                                                                item.dependent_layout && this.props.isRateAssignment === true && drillDownDataLength === 0?
                                                                    <div><a onClick={e=>this.drillDownNextLevel(JSON.stringify(item))} className="cursor-pointer">
                                                                        <Icons iconType={"DoubleRightArrow"} /></a>
                                                                    </div>
                                                                :
                                                                //item.dependent_layout && this.props.isRateAssignment === true && drillDownDataLength>0 && restrictWindows.length>0 && restrictWindows.includes(item.dependent_layout.window_id)?
                                                                item.dependent_layout && this.props.isRateAssignment === true && drillDownDataLength>0 && restrictWindows.length>0 && isDrill === true?
                                                                    <div><a onClick={e=>this.drillDownNextLevel(JSON.stringify(item))} className="cursor-pointer">
                                                                        <Icons iconType={"DoubleRightArrow"} /></a>
                                                                    </div>
                                                                :
                                                                null
                                                            }
                                                        </div>
                                                    </div>                                                                                                    
                                                : // Direct Loop fields loaded here....
                                                <>
                                                {this.state.isFromEmail ? 
                                                ((item.field_name === "-None-" || item.is_request === true) ? (                                                        
                                                <DrillDownList 
                                                        ind={ind}
                                                        drillId={drillId} 
                                                        item={item} 
                                                        val={val} 
                                                        isLookupSelect={isLookupSelect} 
                                                        selectHandler={this.selectHandler} 
                                                        drillDownNextLevel={this.drillDownNextLevel}
                                                        duplicateFieldNames={duplicateFieldNames}
                                                        showLayoutHint={showLayoutHint}
                                                        isItemChecked={isItemChecked}
                                                    />                                                    
                                                ) : null                                                
                                                ) : (                                                    
                                                    <DrillDownList                                                        
                                                    ind={ind}                                                        
                                                    drillId={drillId}                                                        
                                                    item={item}                                                        
                                                    val={val}                                                        
                                                    isLookupSelect={isLookupSelect}                                                        
                                                    selectHandler={this.selectHandler}                                                        
                                                    drillDownNextLevel={this.drillDownNextLevel}
                                                    duplicateFieldNames={duplicateFieldNames}
                                                    showLayoutHint={showLayoutHint}
                                                    isItemChecked={isItemChecked}
                                                    />                                                
                                                )}                                              
                                                </>
                                                    // Ends - Direct Loop fields loaded here....                                                                                                                                                                                           
                                                : null
                                                : null
                                            )
                                        })
                                    : null
                                }
                                 
                                {/* <div className="noFields">No fields found</div>      */}
                                </div>
                            </div>
                        </div>
                         
                    </div>
                </div>
            </Wrp>
        );
    }
    
}
DrillDown.defaultProps = {
    showValue: true,
    isLookupSelect:true,
    isModelOpenDefault:false,
    isAllowAutoClose:true,
    existWindowFields:[],
    isExcludeFields:false,
    isCustomChildren:false,
    imageField:true,
    isConditionApplied:false,
    isDirectFieldOnly:false,
    restrictWindowFields:{fields_with_filters:{window_fields:[]}},
    isRateAssignment:false,
    hocClass:'',
    isPickListFilter:false,
    isCondtionField:true,
    isDisableOutSideClick: false,
    isPositionRelative:false,
    isFetchingData:false,
    showLayoutHint:false,
  }

export default DrillDown;


const renderLayoutVariantHint = (item, duplicateFieldNames, alwaysShowLayout = false) => {
    // Shared/copied fields (same physical column on multiple layouts) stay unlabeled —
    // one common Steps field for all layouts (e.g. Carrier).
    // Hint only when the same display name appears as separate picker rows
    // (different physical fields, e.g. two POD Exist checkboxes).
    const fieldName = isSet(item.field_name, '').trim().toLowerCase();
    const isDuplicateLabel = duplicateFieldNames instanceof Set && fieldName !== ''
        ? duplicateFieldNames.has(fieldName)
        : false;
    if (!isDuplicateLabel && alwaysShowLayout !== true) {
        return null;
    }

    const hint = getWindowFieldLayoutLabel(item);
    if (!hint) {
        return null;
    }
    return (
        <span
            className="text-dark text-medium ml-1"
            style={{ opacity: '0.5', fontStyle: 'italic', fontSize: '0.75rem' }}
            title={hint}>
            ({hint})
        </span>
    );
};

const DrillDownList = (props) => {
    const { ind, drillId, item, isLookupSelect, selectHandler, drillDownNextLevel, duplicateFieldNames, showLayoutHint, isItemChecked } = props;

    const handleSelect = (item) => {
        if (item.dependent_layout && isLookupSelect) {
            selectHandler(item);
        } else if (!item.dependent_layout) {
            selectHandler(item);
        }
    };
    const checked = typeof isItemChecked === 'function' ? isItemChecked(item) : false;
// console.log('item',(item.dependent_layout?.fields_with_filters?.window_fields?.length) > 0)
    return (
        <div className="mainDiv" id={ind === 0 ? "ele" : ""}>
            <div key={ind} className="d-flex align-items-center justify-content-between mb-1">
                <div className="w-75 listClass">
                    <label className="d-flex align-items-center mb-0 cursor-pointer">
                        <input
                            type="radio"
                            name={"fields_" + drillId}
                            className=""
                            value={item.id}
                            checked={checked}
                            onChange={() => handleSelect(item)}
                        />
                        <span className="pl-1 text-truncate" title={item.field_name}>
                            {item.field_name}
                        </span>
                        {renderLayoutVariantHint(item, duplicateFieldNames, showLayoutHint === true)}
                        {item.function_type && (
                            <span
                                className="text-dark text-medium ml-1"
                                style={{ opacity: '0.5', fontStyle: 'italic', fontSize: '0.8rem' }}>
                                ({item.function_type})
                            </span>
                        )}
                    </label>
                </div>
                {(item.dependent_layout && (item.dependent_layout?.fields_with_filters?.window_fields?.length) > 0) ? (
                    <div>
                        <a onClick={() => drillDownNextLevel(JSON.stringify(item))} className="cursor-pointer">
                            <Icons iconType={"DoubleRightArrow"} />
                        </a>
                    </div>
                ):<></>}
            </div>
        </div>
    );
};
